export const LEGAL_STATUS_TYPE_PRIVATE = 1;
export const LEGAL_STATUS_TYPE_COMPANY = 2;